import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  inventoriesData: {},
};

const inventoryListLoader = (state, action) => {
  return {
    ...state,
    inventoriesData: action.responsePayload,
  };
};

const simDropdownData = (state, action) => {
  return {
    ...state,
    simDropdownData: action.responsePayload,
  };
};

const systemProfile = (state, action) => {
  return {
    ...state,
    systemProfile: action.responsePayload,
  };
};
const editInventoryData = (state, action) => {
  return {
    ...state,
    editInventoryInfo: action.requestPayload,
  };
};

const handlers = {
  [actions.SAVE_INVENTORY_LIST]: inventoryListLoader,
  [actions.SAVE_SIM_DROPDOWN_DATA]: simDropdownData,
  [actions.SAVE_SYSTEM_PROFILE_DATA]: systemProfile,
  [actions.STORE_EDIT_INVENTORY_DATA]: editInventoryData,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
